export const base64StringToFileBlob = (
  base64String: string,
  filename: string,
) => {
  var byteString = atob(base64String);
  var bytes = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    bytes[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([bytes.buffer], {type: 'image/png'});
  return new File([blob], 'image.png', {type: 'image/png'});
};

export const imageUrlToFileBlob = async (url: string, filename: string) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, {type: 'image/png'});
};
